module["exports"] = [
  "#{city_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/address/city.js
// module id = 1178
// module chunks = 0